import type { UseFormReturn } from 'react-hook-form'

import { getCustomerInformationsWithSiret } from '@/services/queries'
import { type Translator, type UserTypeWatchType } from '@/types'
import { siretValidation } from '@/schemas/schemaValidations'

type UpdateFieldsType = {
  updatedField: string
  values: UserTypeWatchType['values']
  form: React.RefObject<UseFormReturn | null>
  isUser: boolean
  stateName?: 'profil'
  setState?: React.Dispatch<React.SetStateAction<string>>
  t: Translator
}

/**
 *
 * @param actionField is the field that has been updated
 * @param values are the values of the form
 * @param form is the form reference
 * @param isUser is a boolean to know if the form is for a user or a customer
 * @param stateName is the name of the state to update
 * @param setState is the function to update the state
 * @returns
 */
export const updateFields = async ({
  updatedField,
  values,
  form,
  isUser,
  stateName,
  setState,
  t,
}: UpdateFieldsType) => {
  if (
    updatedField === 'SIRET' &&
    values?.SIRET &&
    siretValidation(t).safeParse(values.SIRET).success
  ) {
    const numbersWithSpacesRegex = /^[0-9\s]*$/
    if (!numbersWithSpacesRegex.test(values.SIRET)) {
      return
    }

    const result = await getCustomerInformationsWithSiret(values.SIRET)
    const data = result?.data
    if (data) {
      form.current?.setValue(isUser ? 'company' : 'companyName', data.name)
      form.current?.setValue('address', data.address)
      form.current?.setValue('zipcode', data.zipcode)
      form.current?.setValue('city', data.city)
      form.current?.setValue('country', data.country)
    } else {
      form.current?.setValue(isUser ? 'company' : 'companyName', '')
      form.current?.setValue('address', '')
      form.current?.setValue('zipcode', '')
      form.current?.setValue('city', '')
      form.current?.setValue('country', '')
    }
  }
  if (updatedField === 'SIRET' && !values?.SIRET) {
    form.current?.setValue(isUser ? 'company' : 'companyName', '')
    form.current?.setValue('address', '')
    form.current?.setValue('zipcode', '')
    form.current?.setValue('city', '')
    form.current?.setValue('country', '')
  }

  if (updatedField === 'type' && setState && stateName === 'profil') {
    setState(values?.type?.value)
  }
}
